import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TabsList from "./TabsList";

export const SHIELD_CARE_TAB_DOCTORS = "doctors";
export const SHIELD_CARE_TAB_PHARMACIES = "pharmacies";
export const SHIELD_CARE_TAB_MEDICATIONS = "medications";
export const SHIELD_CARE_TAB_INTAKE_LOGS = "intake_logs";

/**
 * Cross-route tabs between Shield Care Doctors, Pharmacies, Medications, and Intake Logs.
 */
export default function ShieldCareSectionTabs({ activeTab }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const showDoctors = hasPermission && hasPermission("menu.shield_care_doctors");
  const showPharmacies = hasPermission && hasPermission("menu.shield_care_pharmacies");
  const showMedications = hasPermission && hasPermission("menu.shield_care_medications");
  const showIntakeLogs = hasPermission && hasPermission("menu.shield_care_intake_logs");

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Shield Care sections">
      {showDoctors ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === SHIELD_CARE_TAB_DOCTORS}
          className={`tab-btn ${activeTab === SHIELD_CARE_TAB_DOCTORS ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== SHIELD_CARE_TAB_DOCTORS) navigate("/ShieldCare/Doctors");
          }}
        >
          Doctors
        </button>
      ) : null}
      {showPharmacies ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === SHIELD_CARE_TAB_PHARMACIES}
          className={`tab-btn ${activeTab === SHIELD_CARE_TAB_PHARMACIES ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== SHIELD_CARE_TAB_PHARMACIES) navigate("/ShieldCare/Pharmacies");
          }}
        >
          Pharmacies
        </button>
      ) : null}
      {showMedications ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === SHIELD_CARE_TAB_MEDICATIONS}
          className={`tab-btn ${activeTab === SHIELD_CARE_TAB_MEDICATIONS ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== SHIELD_CARE_TAB_MEDICATIONS) navigate("/ShieldCare/Medications");
          }}
        >
          Medications
        </button>
      ) : null}
      {showIntakeLogs ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === SHIELD_CARE_TAB_INTAKE_LOGS}
          className={`tab-btn ${activeTab === SHIELD_CARE_TAB_INTAKE_LOGS ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== SHIELD_CARE_TAB_INTAKE_LOGS) navigate("/ShieldCare/IntakeLogs");
          }}
        >
          Intake Logs
        </button>
      ) : null}
    </TabsList>
  );
}
